module.exports = __webpack_public_path__ + "img/base_divers_geocaching.5b88c50d.svg";